import React, { useMemo } from 'react';
import { calculateTotal, formatMoney, parseDecimal } from './money';

const Totals = ({ rows = [] }) => {
    const totals = useMemo(() => {
        return rows.reduce(
            (summary, row) => {
                const usages = row.usage ?? [];

                usages.forEach((usage) => {
                    const quantity = parseDecimal(usage.quantity);
                    const total = calculateTotal(usage.price, usage.quantity, usage.total);

                    if (Number.isFinite(quantity)) {
                        summary.totalLicenses += quantity;
                    }

                    if (Number.isFinite(total)) {
                        summary.totalPrice += total;
                    }
                });

                return summary;
            },
            {
                totalLicenses: 0,
                totalPrice: 0,
            }
        );
    }, [rows]);

    const formattedLicenses = Number.isInteger(totals.totalLicenses)
        ? totals.totalLicenses
        : totals.totalLicenses.toFixed(2);

    return (
        <tr>
            <td colSpan={2} className="bg-secondary"></td>

            <td className="bg-secondary text-white text-end">
                Licenties: {formattedLicenses}
            </td>

            <td className="bg-secondary text-white text-end">
                Totaal: {formatMoney(totals.totalPrice, 2)}
            </td>
        </tr>
    );
};

export default Totals;
